import LinkToDocusaurus from '../LinkToDocusaurus'
import { monitorRunner } from '../../docs-routes'

const LinkToMonitorRunnerDoc = () =>
  <LinkToDocusaurus path={monitorRunner}>
    Learn more about Monitor Runner
  </LinkToDocusaurus>

export default LinkToMonitorRunnerDoc
